import { useEffect } from 'react';
import { useMatch, useNavigate, Outlet } from 'react-router-dom';
import { PermissionDenied, PermissionEnum } from '@ui/src';
import { useAppSelector } from '@store';

import ROUTES from '../../routes';

import cn from './styles.module.css';

const Fintrac = () => {
  const match = useMatch(ROUTES.FINTRAC);
  const navigate = useNavigate();

  const { activePermissions } = useAppSelector((state) => state.root);

  useEffect(() => {
    if (
      match &&
      activePermissions?.includes(PermissionEnum.REGULATORY_REPORT_FINTRAC_LIST)
    ) {
      navigate(ROUTES.FINTRAC_EFTR);
    }
  }, [match, activePermissions]);

  let content;

  if (
    !activePermissions?.includes(PermissionEnum.REGULATORY_REPORT_FINTRAC_LIST)
  ) {
    content = <PermissionDenied />;
  } else {
    content = <Outlet />;
  }

  return <div className={cn.fintrac}>{content}</div>;
};

export default Fintrac;
